import React, { useEffect } from "react";
import { Icon } from "design-system/components/icon/icon";
import { Portal } from "components/portal/portal";
import { useLockBodyScroll } from "hooks/use-lock-body-scroll/use-lock-body-scroll";
import {
  FullscreenCloseButton,
  FullscreenImage,
  FullscreenOverlay
} from "./practice-fullscreen-image.styles";

interface PracticeFullscreenImageProps {
  imageUrl: string;
  visible: boolean;
  alt?: string;
  onClose: () => void;
}

export const PracticeFullscreenImage: React.FC<
  PracticeFullscreenImageProps
> = ({ imageUrl, visible, alt = "Practice image", onClose }) => {
  useLockBodyScroll(visible);

  useEffect(() => {
    if (!visible) return;

    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === "Escape") onClose();
    };

    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [onClose, visible]);

  if (!visible || !imageUrl) return null;

  return (
    <Portal>
      <FullscreenOverlay
        role="dialog"
        aria-modal="true"
        aria-label="Gambar latihan"
        onClick={onClose}
      >
        <FullscreenCloseButton
          type="button"
          aria-label="Tutup gambar"
          onClick={(event: React.MouseEvent<HTMLButtonElement>) => {
            event.stopPropagation();
            onClose();
          }}
        >
          <Icon name="action-close" />
        </FullscreenCloseButton>
        <FullscreenImage
          src={imageUrl}
          alt={alt}
          onClick={(event: React.MouseEvent<HTMLImageElement>) =>
            event.stopPropagation()
          }
        />
      </FullscreenOverlay>
    </Portal>
  );
};
